import { dataAtPath } from "../runtime";
import type { FormRuntime } from "../runtime";
import type { TimeZoneContext } from "../TimeZoneContext";
import type { ReferenceLabelStore } from "./reference-label-store";

export interface FormSession {
	runtime: FormRuntime;
	timeZones: TimeZoneContext;
	referenceLabels?: ReferenceLabelStore;
	revision: number;
	readonly: boolean;
	showErrors: boolean;
	pendingEdits?: Set<PendingFormEdit>;
	update(path: string, value: unknown): void;
}

export function clearHiddenTimeZones(session: FormSession): boolean {
	return session.timeZones.clearHidden(path => session.runtime.isVisible(path)
		&& dataAtPath(session.runtime.data, path) != null);
}

export interface PendingFormEdit {
	isActive(): boolean;
}

export function hasPendingEdits(session: FormSession): boolean {
	return [...(session.pendingEdits ?? [])].some(edit => edit.isActive());
}

export interface FormValidationResult {
	valid: boolean;
	messages: string[];
}

export interface FormOptions {
	readonly?: boolean;
	readOnly?: boolean;
	onChange?: (value: unknown) => void;
}

export interface FormChange {
	value: unknown;
	result: FormValidationResult;
	reset?: boolean;
}

export interface FormValidationRequest {
	onValidated(value: unknown, result: FormValidationResult): void;
}
